<template>
  <div class="content-area content-wrapper" id="store-operation">
    <div class="title-area title-only bg-light-blue">
      <img src="../../assets/images/CLEVAS_back.png">
      <div class="page-title">
        ユーザー登録 お申し込み
      </div>
    </div>
    <section class="content">
      <el-row>
        <el-col :xs="{span: 24, offset: 0}" :sm="{span: 20, offset: 2}" :md="{span: 18, offset: 3}" :lg="{span: 14, offset: 5}" :xl="{span: 12, offset: 6}">
          <el-card class="text-center card-width">
            <div class="form-card">
              <div v-if="!isSend">
                <user-flow :step="1"></user-flow>
                <el-row>
                  <el-col :xs="{span: 22, offset: 1}" :sm="{span: 20, offset: 2}" :md="{span: 20, offset: 2}" :lg="{span: 20, offset: 2}" :xl="{span: 18, offset: 3}">
                    <div class="form-content text-center">
                      <el-form @submit.native.prevent="" :model="form" :rules="rules" ref="form" label-width="120px">
                        <el-form-item label="メールアドレス" prop="email">
                          <el-input v-model="form.email"></el-input>
                        </el-form-item>
                      </el-form>
                    </div>
                  </el-col>
                </el-row>
                <div class="description">
                  <div class="description word-brake-float-left">
                    ※ ご入力いただいたメールアドレスがログイン時のユーザーIDとなります。<br>
                    ※「{{ fromAddress.split('@')[1] }}」からのメールが受信できるように設定をお願いいたします。
                  </div>
                </div>

                <el-row class="mb-50px">
                  <el-checkbox v-model="agreePrivacy"><a :href="privacyPolicyUrl" target="_blank" rel="noopener noreferrer">個人情報の取り扱いについて</a>に同意する</el-checkbox>
                </el-row>
                <el-button
                  type="warning"
                  :disabled="!agreePrivacy || form.email == '' || isDisabledButton"
                  @click="createUser"
                  class="regist-button"
                  v-loading="isLoadingButton"
                >
                  申し込む
                </el-button>
              </div>
              <div v-else>
                <user-flow :step="1"></user-flow>
                <div class="word-brake-float-left">
                  ご入力いただいたメールアドレスにメールを送信いたしました。
                </div><br>
                <div class="word-brake-float-left">
                  メールに記載されているURLからStep2ユーザー情報登録へお進みください。
                </div>
                <div class="description word-brake-float-left">
                  ※メールの送信にはお時間がかかる場合がございます。<br>
                  ※メールが届かない場合、「photron.co.jp」からの受信が許可されていないか、入力したメールアドレスに誤りがあった可能性があります。確認の上、再度お申し込みください。<br>
                  ※メールに記載のURLは1時間有効です。<br>1時間以内にアクセスいただけなかった場合は、再度お申し込みください。
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </section>
  </div>
</template>

<script>
  import 'babel-polyfill';
  import http_method from '../mixins/http_method';
  import UserFlow from './UserFlow.vue';
  export default {
    name: "UserCreate",
    components: { UserFlow },
    data() {
      return {
        isSend: false,
        form: {
          email: "",
        },
        agreePrivacy: false,
        agreeTerms: false,
        isDisabledButton: false,
        isLoadingButton: false,
        isClickedButton: false,
        rules: {
          email: [
            { required: true, message: 'メールアドレスを入力してください', trigger: 'blur' },
            { type: 'email', message: '正しく入力してください', trigger: 'blur' },
            { max: 64, message: "64文字以内で入力してください", trigger: 'change' },
            {
              validator: (rule, value, callback) => {
                if(value.match(/^[A-Za-z0-9@._-]*$/) == null){
                  callback(new Error("使用できる文字は半角英数字と記号の @ _ - . のみです"));
                }else{
                  callback();
                }
              }
            }
          ],
        }
      }
    },
    props: {
      defaultParams: {
        type: Object,
        default: () => ({})
      },
      fromAddress: {
        type: String,
        default: ""
      },
      privacyPolicyUrl: {
        type: String,
        default: ""
      },
    },
    mixins: [http_method],
    created() {
      
    },
    methods: {
      async createUser(){
        this.isLoadingButton = true;
        this.isClickedButton = true;
        // 登録ボタンが押された際にバリデーションをかける
        this.$refs["form"].validate(async (valid) => {
          if(valid) {
            const res = await this.postMethod(this.form, "/users", "登録に失敗しました。もう一度やり直してください。")
            if(res.data.status == 'error'){
              console.error(res)
              this.$message({
                type: 'error',
                message: res.data.message,
                duration: 0,
                showClose: true
              });
            }else{
              this.isSend = true;
            }
          } else {
            this.isDisabledButton = true;
            console.log('error submit!!');
            return false;
          }
        });
        this.isLoadingButton = false;
      },
    },
    watch: {
      form: {
        handler (val, old) {
          if(this.isClickedButton) {
            // バリデーションの結果を更新する
            this.$refs["form"].validate(async (valid) => {
              this.isDisabledButton = !valid;
            });
            // バリデーションの結果を判定する
            let isSomeEmpty = false;  // 空値
            let hasSomeError = false; // バリデーションエラー
            let isValid = false;
            this.$refs.form.fields.forEach((field) => {
              if (field.validateState == "error") isSomeEmpty = true
              if (field.validateState == "") hasSomeError = true;
              isValid = isValid || isSomeEmpty || hasSomeError;
            });
            this.isDisabledButton = isValid
          }
        },
        deep: true
      }
    },
  }
</script>
